import React from 'react';

const LoadingIndicator = () => (
  <div
    className="college-earnings-loading-indicator"
    data-testid="college-earnings-loading-indicator"
  >
    <div className="college-earnings-loading-indicator-header-container">
      <h1 className="college-earnings-loading-indicator-header">Following</h1>
    </div>
    <div className="prefix-flex prefix-align-items college-earnings-loading-indicator-card">
      <div className="college-earnings-loading-indicator-image-placeholder shimmer"></div>
      <div>
        <div className="college-earnings-loading-indicator-top-row-placeholder shimmer"></div>
        <div className="college-earnings-loading-indicator-bottom-row-placeholder shimmer"></div>
      </div>
    </div>
  </div>
);

export default LoadingIndicator;
